/* ADDED FILE */
/* UNTAPPED - GENERAL */

/**
 * 
 * This utility is a dynamic version of: 
 *   const el = root.querySelector(selector);
 * 
 * It differs in that it does not presuppose that the element is already in the dom, but detects 
 * whenever one is added and invokes the callback to interact with the element.
 * 
 * It is designed to make it easier to handle the way that Kalles interacts with 
 * the dom, eg where whole areas of the DOM are replaced.
 * 
 * @returns {() => void}
 *   Cleanup function (disconnects observer)
 */
export function onAddElement({ root, selector, onNode }) { 
  const rootEl =
    typeof root === 'string' ? document.querySelector(root) : root;

  if (!rootEl) {
    console.warn('[onAddElement] root not found:', root);
    return () => {};
  }

  // Tracks which *physical DOM nodes* we've already handed off
  const seen = new WeakSet();

  function process(node) {
    if (!(node instanceof Element)) return;

    // Node itself matches
    if (node.matches(selector)) {
      if (!seen.has(node)) {
        seen.add(node);
        onNode(node);
      }
    }

    // Descendants match
    node.querySelectorAll(selector).forEach((el) => {
      if (!seen.has(el)) {
        seen.add(el);
        onNode(el);
      }
    });
  }

  // Initial scan (important)
  process(rootEl);

  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.type !== 'childList') continue;

      // Only care about added nodes (structural creation)
      m.addedNodes.forEach(process);
    }
  });

  observer.observe(rootEl, {
    childList: true,
    subtree: true,
  });

  return () => observer.disconnect();
}

/**
 * Observe all mutations for an element and its descendants, with debounce to 
 * handle bursts of updates that have been seen when interacting with other apps. 
 * 
 * onSettel must be idempotent - ie if it is called because of its own update
 * it will not update again.
 */
export function observeSettledContent({
  root,
  onSettle,
  debounce = 50
}) {
  if (!(root instanceof Node)) {
    console.warn('[observeSettledContent] invalid root:', root);
    return () => {};
  }

  let timer = null;

  const observer = new MutationObserver(() => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      onSettle(root);
    }, debounce);
  });

  observer.observe(root, {
    childList: true,
    subtree: true,
    characterData: true
  });

  // Important: run once immediately for initial state
  onSettle(root);

  return () => {
    clearTimeout(timer);
    observer.disconnect();
  };
}

/**
 * Utility to log all mutations under a given root.  Useful for understanding what is being done
 * to elements we are interested in by the theme and other apps.  
 * 
 * Simply uncomment the call to it.
 */

function consoleLogAllMutations(root = document.body) {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((m) => {
      console.log("MUTATION: ", m);
    });
  });

  observer.observe(root, {
    subtree: true,
    childList: true,
    characterData: true,
  });

  console.log('🔍 Kalles price mutation observer attached');
};
// consoleLogAllMutations(document.querySelector('.is-sold-by-length')[0]);



// REDUNDANT CODE - THIS WAS A VERSION THAT ADDED DEBOUNCE WHICH MIGHT BE USEFUL IN THE
// FUTURE.

// export function onAddElement({ root, selector, onNode, debounce = 0 }) {
//   const rootEl =
//     typeof root === 'string' ? document.querySelector(root) : root;

//   if (!rootEl) {
//     console.warn('[onAddElement] root not found:', root);
//     return () => {};
//   }

//   const seen = new WeakSet();

//   // New: pending queue for debounced mode
//   const pending = new Set();
//   let timer = null;

//   function flush() {
//     timer = null;
//     pending.forEach(node => {
//       if (!seen.has(node)) {
//         seen.add(node);
//         onNode(node);
//       }
//     });
//     pending.clear();
//   }

//   function enqueue(node) {
//     if (!(node instanceof Element)) return;

//     if (node.matches(selector)) {
//       pending.add(node);
//     }

//     node.querySelectorAll(selector).forEach(el => {
//       pending.add(el);
//     });
//   }

//   function process(node) {
//     if (!(node instanceof Element)) return;

//     if (debounce > 0) {
//       enqueue(node);
//       clearTimeout(timer);
//       timer = setTimeout(flush, debounce);
//     } else {
//       if (node.matches(selector) && !seen.has(node)) {
//         seen.add(node);
//         onNode(node);
//       }

//       node.querySelectorAll(selector).forEach(el => {
//         if (!seen.has(el)) {
//           seen.add(el);
//           onNode(el);
//         }
//       });
//     }
//   }

//   // Initial scan
//   process(rootEl);

//   const observer = new MutationObserver(mutations => {
//     for (const m of mutations) {
//       if (m.type !== 'childList') continue;
//       m.addedNodes.forEach(process);
//     }
//   });

//   observer.observe(rootEl, {
//     childList: true,
//     subtree: true,
//   });

//   return () => observer.disconnect();
// }
